import GaugeWithNeedle from '../../../../../../../components/Charts/GaugeNeedle/GaugeWithNeedle'



export default function GetImmuneGauge() {

  return (

      <GaugeWithNeedle realAge={64} chronologicalAge={62} />
    
  );
};




